/* ============================================================================
   ss-reviews.js — 2 nút prev/next cho carousel review (ss-reviews.liquid)

   Cuộn/snap do CSS lo (overflow-x + scroll-snap). JS CHỈ:
     · nhảy sang thẻ trước/kế bằng scrollTo (khớp scroll-padding của carousel)
     · bật/tắt disabled 2 nút theo vị trí cuộn
     · ẩn cụm nút khi băng không tràn (không có gì để cuộn)

   Bóc từ script gốc web mau (pdp-view-btw.html dòng 27036-27105).
   Chạy được nhiều section trên cùng trang; an toàn với theme editor.
   ========================================================================== */
(function () {
  'use strict';

  function initReviews(root) {
    if (!root || root.dataset.ssrReady === '1') return;

    var carousel = root.querySelector('[data-ssr-carousel]');
    var cards = root.querySelectorAll('[data-ssr-card]');
    if (!carousel || cards.length === 0) return;

    root.dataset.ssrReady = '1';

    var prevBtn = root.querySelector('[data-ssr-prev]');
    var nextBtn = root.querySelector('[data-ssr-next]');
    var controls = root.querySelector('[data-ssr-controls]');

    function padLeft() {
      return parseFloat(window.getComputedStyle(carousel).paddingLeft) || 0;
    }

    function targetScroll(index) {
      if (index < 0) index = 0;
      if (index >= cards.length) index = cards.length - 1;
      return cards[index].offsetLeft - padLeft();
    }

    function currentIndex() {
      var pad = padLeft();
      var best = 0;
      var minDiff = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var diff = Math.abs(carousel.scrollLeft - (cards[i].offsetLeft - pad));
        if (diff < minDiff) {
          minDiff = diff;
          best = i;
        }
      }
      return best;
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var scrollLeft = Math.ceil(carousel.scrollLeft);
      var maxScroll = Math.floor(carousel.scrollWidth - carousel.clientWidth);

      if (maxScroll <= 5) {
        if (controls) controls.style.display = 'none';
        return;
      }
      if (controls) controls.style.display = '';

      prevBtn.disabled = scrollLeft <= 5;
      nextBtn.disabled = scrollLeft >= maxScroll - 5;
    }

    function go(step) {
      carousel.scrollTo({ left: targetScroll(currentIndex() + step), behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

    carousel.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  /* Lưới an toàn cho .ss-reveal: hiệu ứng do IntersectionObserver DÙNG CHUNG
     trong ss-main-product.js lo. Nếu trang KHÔNG có file đó (dùng ss-reviews
     một mình ở page khác) thì thẻ sẽ kẹt opacity 0 — khi ấy hiện thẳng ra.
     Đây chỉ là guard, KHÔNG dựng lại observer thứ hai. */
  function revealFallback(root) {
    if (document.querySelector('script[src*="ss-main-product.js"]')) return;
    var els = root.querySelectorAll('.ss-reveal:not(.is-in)');
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('ss-reviews');
    for (var i = 0; i < nodes.length; i++) {
      initReviews(nodes[i]);
      revealFallback(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* theme editor: section được render lại thì gắn lại sự kiện */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
